import { apiPost } from "../baseApi";

export const refreshOtp = async (data) => {
  try {
    const response = await apiPost("_refreshOtp", data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
